import React from 'react'
import styled, { keyframes } from 'styled-components'

type Props = {
  size?: number
}

const LiveCallStatus: React.FC<Props> = ({ size = 10 }) => (
  <PulseContainer dotSize={size}>
    <Pulse dotSize={size} />
    <Dot dotSize={size} />
  </PulseContainer>
)

const PulseContainer = styled.div<{ dotSize: number }>`
  position: relative;
  height: ${(p) => p.dotSize}px;
  width: ${(p) => p.dotSize}px;
  margin-right: 10px;
`
const Dot = styled.div<{ dotSize: number }>`
  background-color: ${(p) => p.theme.colors.white};
  width: ${(p) => p.dotSize}px;
  height: ${(p) => p.dotSize}px;
  border-radius: 50%;
  position: relative;
`

const PulseAnim = keyframes`
  0% { opacity: 0.75; transform: scale(1); } /* stylelint-disable-line */
  100% { opacity: 0; transform: scale(2.5); } /* stylelint-disable-line */
`

const Pulse = styled.div<{ dotSize: number }>`
  background-color: ${(p) => p.theme.colors.white};
  width: ${(p) => p.dotSize}px;
  height: ${(p) => p.dotSize}px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(1);
  opacity: 0.75;
  animation: ${PulseAnim} 1s infinite;
`
export default LiveCallStatus
